export const STORE_ME_PENDING = 'store_me_pending';
export const STORE_ME_SENDING = 'store_me_sending';
export const STORE_ME_FAILED = 'store_me_failed';
export const STORE_ME_SAVED = 'store_me_saved';
export const STORE_ME_RESET_STATUS = 'store_me_reset_status';
export const STORE_ME_RECEIVED = 'store_me_received';
